module.exports = __webpack_public_path__ + "static/media/main_103.c70da93f.ico";